import React from 'react';
import {View, StyleSheet, Text, TextStyle} from 'react-native';
import {Colors, Sizes, TextStyles} from '..';
import {ComponentProps} from './ComponentProps';

interface BadgeProps extends ComponentProps {
  text: string;
  isInverse?: boolean;
}

export const BadgePrimary = (props: BadgeProps) => {
  return (
    <Badge
      {...{...props}}
      height={18}
      textStyle={TextStyles.textMediumXSBold}
      color={Colors.primary}
      textColor={Colors.brandWhite}
    />
  );
};

interface BadgeInternalProps extends BadgeProps {
  height: number;
  textStyle: TextStyle;
  textColor: string;
  color: string;
}

const Badge = (props: BadgeInternalProps) => {
  const isInverse = props.isInverse ?? false;
  let pillStyle = [
    styles.pill,
    {
      height: props.height,
      borderRadius: props.height / 2,
      backgroundColor: isInverse ? props.textColor : props.color,
    },
  ];
  let textStyle = [props.textStyle, {color: isInverse ? props.color : props.textColor}];
  return (
    <View style={props.containerStyle}>
      <View style={styles.container}>
        <View style={pillStyle} testID={props.testID}>
          <Text style={textStyle}>{props.text}</Text>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  // prevents badge from taking all the available width of his parent
  container: {flexDirection: 'row'},
  pill: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: Sizes.xs,
  },
});
